import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { HelpService } from './help.service';
import { HelpArticleSummary } from './models/help-article.model';
import { GENERAL_COLLECTION, helpIcon } from './help-icon';

interface CollectionCard {
  collection: string;
  count: number;
  icon: string;
}

/**
 * Renders the collection-card grid (one card per top-level Section). Navigation-agnostic: emits
 * [openCollection] rather than routing, so the host (standalone route / portal route / drawer) decides
 * what happens. Hosts supply their own hero/search chrome.
 */
@Component({
  selector: 'ee-help-home',
  templateUrl: './help-home.component.html',
  styleUrls: ['./help-home.component.scss'],
  standalone: false,
})
export class HelpHomeComponent implements OnInit {
  @Output() openCollection = new EventEmitter<string>();

  loading = true;
  error = false;
  collections: CollectionCard[] = [];

  constructor(private helpService: HelpService) {}

  ngOnInit(): void {
    this.helpService.list().subscribe({
      next: (articles) => {
        this.collections = this.build(articles);
        this.loading = false;
      },
      error: () => {
        this.error = true;
        this.loading = false;
      },
    });
  }

  private build(articles: HelpArticleSummary[]): CollectionCard[] {
    const counts = new Map<string, number>();
    for (const article of articles) {
      const key = article.section || GENERAL_COLLECTION;
      counts.set(key, (counts.get(key) ?? 0) + 1);
    }
    return Array.from(counts.entries())
      .map(([collection, count]) => ({ collection, count, icon: helpIcon(collection) }))
      .sort((a, b) => a.collection.localeCompare(b.collection));
  }
}
